export default "__VITE_ASSET__vB0R2w4f__"